module.exports = __webpack_public_path__ + "img/202405_01.4cb839a2.jpg";